export default "__VITE_ASSET__BOsVESNt__"